import { useEffect, useState } from 'react';
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from '../../components/sections/mainwebsite/Header';
import ScrollToTop from 'react-scroll-to-top';
import { Footer } from '../../components/sections/footer';
import { AxiosInstance } from '../../components/utils';
import MainWebFooter from '../../components/sections/mainwebsite/mainwebfooter';

interface TeamMember {
  id: number;
  name: string;
  img: string;
  post?: string;
  social: Array<{
    icon: string;
    url: string;
    title: string;
  }>;
}

interface TeamCategory {
  name: string;
  members: TeamMember[];
}

function TeamMembers() {
  const [events, setEvents] = useState<any[]>([]);
  const [teamCategories, setTeamCategories] = useState<TeamCategory[]>([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);

  useEffect(() => {
    const loadTeamData = async () => {
      try {
        // Load all JSON files from resources/json folder
        const jsonFiles = [
          { name: 'Founders', file: '/json/myteam.json' },
          { name: 'Advisory Board', file: '/json/advisoryboardteam.json' },
          { name: 'Event Advisory Board', file: '/json/eventadvisory.json' },
          { name: 'CFP Review Board', file: '/json/chapteradvisoryboardteam.json' },
          { name: 'Core Team', file: '/json/coreteam.json' },
          { name: 'Volunteers Team', file: '/json/Volunteers.json' }
        ];

        const categories: TeamCategory[] = [];

        for (const jsonFile of jsonFiles) {
          try {
            const response = await fetch(jsonFile.file);
            if (response.ok) {
              const members: TeamMember[] = await response.json();
              if (members.length > 0) {
                categories.push({
                  name: jsonFile.name,
                  members: members
                });
              }
            }
          } catch (error) {
            console.warn(`Failed to load ${jsonFile.file}:`, error);
          }
        }

        setTeamCategories(categories);
      } catch (error) {
        console.error('Error loading team data:', error);
      }
    };

    loadTeamData();
  }, []);

  const renderTeamMember = (member: TeamMember) => (
    <div className="team-member" key={member.id}>
      <div className="team-member-inner">
        <div className="team-member-img">
        
          <div className="team-member-initials" style={{ 
            width: '100%', 
            height: '100%', 
            backgroundColor: '#f0f0f0', 
            color: '#666', 
            fontSize: '24px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            borderRadius: '50%'
          }}>
              <img 
            src={member.img} 
            alt={member.name}
            onError={(e) => {
              // Fallback to initials if image fails to load
              const img = e.target as HTMLImageElement;
              img.style.display = 'none';
              const initialsContainer = img.nextElementSibling as HTMLElement;
              if (initialsContainer) {
                initialsContainer.style.display = 'flex';
              }
            }}
          />
          </div>
        </div>
          <div className="team-member-info">
          <h4>{member.name || 'Team Member'}</h4>
          {member.post && <span className="team-member-post">{member.post}</span>}
          <div className="team-member-social">
            {member.social && member.social.map((social, index) => (
              <a key={index} href={social.url} target="_blank" rel="noopener noreferrer" title={social.title}>
                <i className={social.icon}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <style>
        {`
         
          
          .section-title {
            margin-bottom: 60px;
          }
          
          .section-title h2 {
            font-size: 36px;
            font-weight: 700;
            color: #333;
            margin-bottom: 15px;
          }
          
          .section-title p {
            font-size: 16px;d
            color: #666;
          }
          
          .category-title {
            margin-bottom: 30px;
            border-bottom: 2px solid #d1d1d1ff;
            padding-bottom: 10px;
          }
          
          .category-title h3 {
            font-size: 24px;
            font-weight: 600;
            color: #ffffff;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          
          .team-members-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            gap: 30px;
            padding: 20px 0;
          }
          
          .team-member {
            border-radius: 10px;
            box-shadow: 0 5px 15px rgba(0,0,0,0.1);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            overflow: hidden;
          }
          
          .team-member:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 25px rgba(0,0,0,0.15);
          }
          
          .team-member-inner {
            padding: 20px;
            text-align: center;
          }
          
          .team-member-img {
            position: relative;
            width: 200px;
            height: 250px;
            margin: 0 auto 20px auto;
            border-radius: 0%;
            overflow: hidden;
            border: 3px solid #c9c9c9ff;
          }
          
          .team-member-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: opacity 0.3s ease;
          }
          
          .team-member-initials {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            font-size: 24px;
            font-weight: bold;
            text-transform: uppercase;
          }
          
          .team-member-info h4 {
            font-size: 18px;
            font-weight: 600;
            color: #ffffff;
            margin-bottom: 5px;
          }
          
          .team-member-post {
            display: block;
            font-size: 14px;
            color: #b8babbff;
            font-weight: 500;
            margin-bottom: 15px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          
          .team-member-social {
            display: flex;
            justify-content: center;
            gap: 15px;
          }
          
          .team-member-social a {
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f0f0f0;
            color: #333;
            border-radius: 50%;
            text-decoration: none;
            transition: all 0.3s ease;
          }
          
          .team-member-social a:hover {
            background-color: #007bff;
            color: white;
            transform: translateY(-2px);
          }
          
          .no-team-data {
            padding: 40px 0;
          }
          
          .no-team-data p {
            font-size: 18px;
            color: #666;
            font-style: italic;
          }
        `}
      </style>
      
      <div className="antialiased light-vz circle-v ">
        <Header events={events} />
        <br></br>
        <h1 className='spacer-section'></h1>

        {/* Team Members Section */}
        <section className="team-members-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                 <div className="sec-title white-heading-text">
                <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-users fa-stack-1x"></i></span></span>
                <h3 className="wow fadeInRight" data-wow-duration="500ms">Our Team<small> / Meet the dedicated team behind BSidesBangalore</small></h3>
            </div> {/* <!--sec-title end--> */}
              </div>
            </div>

            {teamCategories.map((category, categoryIndex) => (
              <div className="row team-category" key={categoryIndex}>
                <div className="col-lg-12">
                  <div className="category-title">
                    <h3>{category.name}</h3>
                  </div>
                </div>
                
                <div className="col-lg-12">
                  <div className="team-members-grid">
                    {category.members.map(renderTeamMember)}
                  </div>
                </div>
              </div>
            ))}

            {teamCategories.length === 0 && (
              <div className="row">
                <div className="col-lg-12">
                  <div className="no-team-data text-center">
                    <p>Loading team information...</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <MainWebFooter  />  
        <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
      </div>
    </>
  );
}

export default TeamMembers;